function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.374 0 0 4.926 0 11s5.374 11 12 11 12-4.926 12-11S18.626 0 12 0zm5.48 8.577c.004.108.007.217.007.326 0 3.336-2.77 7.183-7.837 7.184a8.319 8.319 0 01-4.222-1.134c.216.023.435.034.657.034 1.29 0 2.478-.403 3.421-1.08-1.205-.02-2.222-.75-2.573-1.754a2.977 2.977 0 001.244-.043c-1.26-.232-2.21-1.253-2.21-2.475v-.032c.372.189.796.302 1.248.315-.74-.452-1.225-1.225-1.225-2.101 0-.463.136-.896.373-1.27C7.72 8.076 9.75 9.08 12.04 9.187a2.324 2.324 0 01-.072-.576c0-1.394 1.234-2.525 2.755-2.525.792 0 1.508.307 2.01.798a5.838 5.838 0 001.75-.613 2.587 2.587 0 01-1.212 1.397 5.888 5.888 0 001.582-.398 5.364 5.364 0 01-1.374 1.308z",
  fill: "currentColor"
});

var SvgTwitterDark = function SvgTwitterDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 22",
    fill: "none"
  }, props), _ref);
};

export default SvgTwitterDark;